import React from "react";

interface SchedulingToolMobileDashTileProps {
    onPress?: () => void;
}

/**
 * SchedulingToolMobileDashTile - A widget component that displays a message for scheduling shifts.
 * The component is clickable and can trigger an action when clicked.
 */ 
const SchedulingToolMobileDashTile: React.FC<SchedulingToolMobileDashTileProps> = ({ onPress }) => {
    return (
        <div className="rounded-lg bg-white w-full" onClick={onPress}>
            <div className="flex">
                {/* <p className="text-base font-medium text-gray-500">Tap to schedule shifts</p> */}
                <p className="text-base text-gray-500">Create and publish team shifts</p>
            </div>
        </div>
    );
};

export default SchedulingToolMobileDashTile;
